(function ($) {

    this.init = function () {
        this.HomeBanner();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.HomeBanner = function () {
        var $slider;

        $slider = $(".homebanner-slides").slick({
            dots: true,
            appendDots: ".homebanner-controls-content-dots",
            dotsClass: "slickdots",
            arrows: false,
            autoplay: true,
            autoplaySpeed: 7000,
            adaptiveHeight: true
        });


        $(".homebanner-pause").click(function () {
            $slider.slick("slickPause");
            $(".homebanner-pause").css("display", "none");
            $(".homebanner-play").css("display", "block");
        });

        $(".homebanner-play").click(function () {
            $slider.slick("slickPlay");
            $(".homebanner-pause").css("display", "block");
            $(".homebanner-play").css("display", "none");
        });

        // After clicking on a dot, we should pause the slideshow

        $(".slickdots button").click(function () {
            console.log("Pause");
            $slider.slick("slickPause");
            $(".homebanner-pause").css("display", "none");
            $(".homebanner-play").css("display", "block");
        });

        $(".homebanner-pause").css("display", "block");
        $(".homebanner-play").css("display", "none");

    };

    this.init();

})(jQuery);